<template lang="pug">
  .content-center
    .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0.page-title.mobile-close(@click="$helpers.redirect('')")
      .arrow-left
        i.fas.fa-chevron-left
      .modal-title.text-capitalize.pl-3 home
    .page-wrap.w-100
      .subpage-tournament
        .tournamentgame-single.t01
          .tournamentgame-detail
            .tournamentgame-pic
              img(src="img/tournamentgame02.png")
            .tournamentgame-wrapper
              .text-small.text-uppercase.text-success.mb-1.tournamentgame-status Current Tournament
              .text-big.font-weight-bold.mb-1.tournamentgame-title Freeroll Tournament
              .text-small.mb-3.tournamentgame-reward Total 17,500 Coins reward per day
              .tournamentgame-time
                .text-mini.mb-1(v-if="onGoing") Time left until finish:
                .text-mini.mb-1(v-else) Countdown before next tournament start:
                .timer
                  ul.m-0.p-0
                    li
                      span#days.text-success {{dayRemain}}
                      | days
                    li
                      span#hours.text-success {{hourRemain}}
                      | Hours
                    li
                      span#minutes.text-success {{minuteRemain}}
                      | Minutes
                    li
                      span#seconds.text-success {{secondsRemain}}
                      | Seconds
          .tournamentgame-prize
            .row.mx-0
              .col-3
                span.pl-1 #
              .col-3.text-center Player
              .col-3.text-center Points
              .col-3.text-center Prize
            template(v-if="onGoing")
              .row.mx-0.d-flex.align-items-center(v-for="(winner, index) in tournamentTop10")
                .col-3
                  span.number {{winner.position}}
                .col-3.text-center {{winner.account}}
                .col-3.text-center {{winner.amount}}
                .col-3.text-center(v-if="index < 3") {{prizeList[index]}} coins
                .col-3.text-center(v-else) - 
            template(v-else)
              .row.mx-0.d-flex.align-items.center
                .col-12.text-center No ongoing tournament
          .tournamentgame-rules
            .rules-title Freeroll Tournament – No Deposit, No Turnover, No Withdraw Requirement
            .rules-table
              .row.mx-0
                .col.text-success Ranking
                .col.text-success Prize
                .col.text-success Withdraw Amount
              .row.mx-0
                .col #1
                .col 2000 coins
                .col MYR 20.00
              .row.mx-0
                .col #2
                .col 1000 coins
                .col MYR 10.00
              .row.mx-0
                .col #3
                .col 500 coins
                .col MYR 5.00
            .rules-detail TERMS & CONDITIONS
            ul.rules-subdetails.mb-4
              li FREE 3 Freeroll Tournament Tickets after member registration.
              li 5 Freeroll Tournament per day – 2pm, 4pm, 6pm, 8pm, 10pm.
              li Each session Freeroll Tournament last for 2 hours.
              li
                span.font-weight-bold NO TURNOVER
                |  – Winner can withdraw directly.
            .rules-detail GENERAL TERMS & CONDITIONS
            ul.rules-subdetails.mb-4
              li A player can only withdrawal 5 times per day.
              li The General Terms & Conditions of Live22 apply to all promotions.
    footerInfo
</template>
<script>
import config from "@/config"
import errorTags from "@/errorTags"
import footerInfo from "@/views/default/_footer.vue";
export default {
  components:{
    footerInfo
  },
  data(){
    return{
      refreshTournament: null,
      feedback:{
        success: true,
        status:""
      },
      tournamentTop10: [],
      onGoing: null,
      startTime: null,
      closeTime: null,
      serverTime: null,
      dayRemain: "00",
      hourRemain: "00",
      minuteRemain: "00",
      secondsRemain: "00",
      prizeList:[2000, 1000, 500]
    }
  },
  destroyed(){
    clearInterval(this.refreshTournament)
  },
  mounted(){
    this.getTournamentInfo();
     this.getTournamentInfo();
    var vm = this
    this.refreshTournament = setInterval(() => {
      vm.getTournamentInfo()
    }, 5000)
  },
  methods:{
    getTournamentInfo(){ 
      let url = "https://tour888.889tech.net/FreeRoll/Operator/CurrentSessionInfo"
      var json = {
        app_id : config.app_id
      }
      this.$http.get(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.status == "200";
              } else {
                this.feedback.success = response.status == 200;
              }

              this.feedback.status = response.status;
              if (this.feedback.success == true) {
                this.tournamentTop10 = [];
                this.onGoing = response.data.Session.IsOngoing;
                if(response.data.Session.Rooms.length > 0){
                  var winners = response.data.Session.Rooms[0].TopPlayer
                  
                  var i = 0;
                  
                  for(i; i < winners.length; i++){
                    var temp = winners[i].split("|");
                    this.tournamentTop10.push({
                      position: temp[0],
                      account: temp[1],
                      amount: temp[2]
                    })
                  }
                }    
                this.startTime = response.data.Session.StartTs;
                this.closeTime= response.data.Session.ClosingTs
                this.serverTime = response.data.Ts
                this.$store.dispatch("user/setTournamentTotal", response.data.Session.Rooms.length)

                if(this.onGoing){
                  var timeRemain = (this.closeTime - this.serverTime) * 1000
                  this.dayRemain =  this.$moment.duration(timeRemain).days();
                  this.hourRemain = this.$moment.duration(timeRemain).hours();
                  this.minuteRemain = this.$moment.duration(timeRemain).minutes();
                  this.secondsRemain = this.$moment.duration(timeRemain).seconds();
                }else{
                  var timeRemain = (this.startTime - this.serverTime) * 1000
                  this.dayRemain =  this.$moment.duration(timeRemain).days();
                  this.hourRemain = this.$moment.duration(timeRemain).hours();
                  this.minuteRemain = this.$moment.duration(timeRemain).minutes();
                  this.secondsRemain = this.$moment.duration(timeRemain).seconds();
                }
                
              } else {
                // if(response.status == 500){
                //   this.$helpers.showDialog(
                //     vm.$tc("ui.attention"),
                //     'Error',
                //     "info",
                //     this
                //   );
                // }
                clearInterval(this.refreshTournament)
              }
            }
          } catch (error) {
            console.log(error);
            clearInterval(this.refreshTournament)
          }
        },
      );    
    },
  }
}
</script>